<template>
  <div class="collect_list">
    <div class="my_collect">我的收藏</div>
    <div class="tab_list flex mt-15 mb-10">
      <div class="btn_tab cursor_pointer" :class="[selectTab == '课程' ? 'active_btn_tab' : '']" @click="changeTab('课程')">
        课程</div>
      <div class="btn_tab cursor_pointer ml-20" :class="[selectTab == '试卷' ? 'active_btn_tab' : '']"
        @click="changeTab('试卷')">试卷</div>
    </div>
    <div v-if="selectTab == '课程'">
      <div class="course_list flex FlexWrap FlexBetween" v-if="hotCourseList.length">
        <div class="flex course_one flexcolumn FlexEvenly" v-for="(item, index) in hotCourseList" :key="index"
          @mouseenter="showDeleteIcon(item)" @mouseleave="hideDeleteIcon" @click="goCourseDetail(item?.courseInfo)">
          <div class="course_one_top">
            <el-image class="course_one_img" :class="[resizeImg ? 'course_one_img_resize' : '']"
              :src="imgPath(item?.courseInfo.courseCoverImg)"></el-image>
            <div class="course_one_type cursor_pointer" v-if="hoverId == item?.courseInfo.courseId"
              @click.stop="removeCollectedCourse(item)">
              <el-image class="delete_gray_icon" :src="iconPath('delete_gray_icon.png')"></el-image>
            </div>
          </div>
          <div class="course_one_title toverflows toverflow2">{{ item?.courseInfo.courseName }}</div>
          <div class="course_one_institution flex FlexBetween">
            <div class="course_one_institution_left flex Flexalign">
              <el-avatar :size="24" :src="item?.courseInfo.shopLogo" />
              <div class="institutionName toverflow">{{ item?.courseInfo.shopName }}</div>
            </div>
            <div class="course_num">{{ item?.courseInfo?.chapterCountResult?.chapterNum }}课时</div>
          </div>
          <div class="course_rate">
            <el-rate v-model="item.courseInfo.rateValue" disabled show-score text-color="#666666"
              score-template="{value}分" />
          </div>
          <div class="flex FlexBetween Flexalign course_info">
            <div class="course_online">{{ item?.courseInfo?.courseExtra?.userNum }}人正在学习</div>
            <!-- <div class="course_price">
          <span class="course_price_unit">￥</span>{{ item?.courseInfo.coursePrice }}
        </div> -->
            <div class="course_price" v-if="item?.courseInfo.saleMethod == 2">
              <span class="course_price_unit">￥</span>{{ item?.courseInfo.saleMethod == 2 ? item?.courseInfo.coursePrice
                :
                0 }}
            </div>
            <div class="course_price course_free" v-else>免费</div>
          </div>
        </div>
        <div v-if="hotCourseList.length % 3 != 0 && !resizeImg" class="flex">
          <div class="empty_course_one course_one" v-for="item in 3 - (hotCourseList.length % 3)" :key="item">
            <div class="course_one_top">
              <el-image class="course_one_img" style="border-radius: 20px" :src="imgPath('course_img.png')"></el-image>
              <div class="course_one_type">热销</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <moe-empty url="moe_empty_bg_img.png" emptyText="暂无收藏课程"></moe-empty>
      </div>
    </div>
    <div v-else>
      <div v-if="testPaperList.length">
        <div class="test_paper_one pb-10 mb-15 flex Flexalign Flexbetween" v-for="(item, index) in testPaperList"
          :key="index">
          <el-image class="test_paper_cover_icon" :src="iconPath('test_paper_cover_icon.svg')"></el-image>
          <div class="paper_info flex-1 flex flexcolumn ml-15">
            <div class="toverflow paper_name">{{ item.paperDocumentName }}</div>
            <div class="paper_tag flex mt-10">
              <div class="tag_one px-10 py-5 mr-10">
                {{
                  gradeList.filter((sitem) => sitem.stageId == item.stageId)[0]
                    ?.stageName
                }}
              </div>
              <div class="tag_one px-10 py-5 mr-10">
                {{
                  gradeList.filter((sitem) => sitem.gradeId == item.gradeId)[0]
                    ?.gradeName
                }}
              </div>
              <div class="tag_one px-10 py-5 mr-10">
                {{
                  item.year
                }}
              </div>
              <div class="tag_one px-10 py-5 mr-10">
                {{
                  originSubjectList.filter(
                    (sitem) => sitem.subjectId == item.subjectId
                  )[0]?.subjectName
                }}
              </div>
            </div>
            <div class="flex Flexalign paper_create mt-10">
              <div>{{ $Moment(item.updateTime).format("MM-DD") }}发布</div>
              <div class="ml-10">浏览量：{{ item.viewCount }}</div>
              <div class="ml-10">下载量：{{ item.downloadCount }}</div>
              <div class="ml-10">创建人：{{ item.createByName }}</div>
            </div>
          </div>
          <div class="paper_difficult ml-10 flex flexcolumn FlexEnd FlexBetween">
            <el-rate v-model="item.difficulty" disabled :max="7" size="small" />
            <!--  -->
            <div class="btn_start px-10 btn_buy cursor_pointer flex Flexalign" @click="payOrder(item.paperDocumentId)"
              v-if="item.feeType == 2&&item.isBuy==false">
              <div>￥{{ item.price }}</div>
              <div class="ml-10">立即购买</div>
            </div>
            <div class="btn_start px-30 cursor_pointer" @click="viewExamPaper(item)" v-else>
              查看
            </div>
          </div>
        </div>
        <div class="pagination_box mar_top_20 flex FlexjustifyEnd" v-if="listTotal > listParams.pageSize">
          <el-pagination background layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40]" :total="listTotal"
            v-model:page-size="listParams.pageSize" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
      <div v-else>
        <moe-empty url="moe_empty_bg_img.png" emptyText="暂无试卷"></moe-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "GjkcH5CollectList",
  props: {
    resizeImg: {}
  },
  computed: {
    ...mapState({
      originSubjectList: (state) => state.filter.subjectList,
      gradeList: (state) => state.filter.gradeList,
      stageList: (state) => state.filter.stageList,
    }),
  },
  data() {
    return {
      hotCourseList: [],
      listQuery: {
        page: 1,
        pageSize: 10,
      },
      listTotal: "",
      hoverId: "",
      selectTab: '课程',
      listParams: {
        page: 1,
        pageSize: 10,
      },
      testPaperList: [],
    };
  },

  mounted() {
    this.getCollectCourseList();
  },

  methods: {
    // 去购买
    payOrder(paperDocumentId) {
      this.$Jump.href("/examPaperOrderConfirm", { paperDocumentId: paperDocumentId });
    },
    changeTab(tab) {
      this.selectTab = tab;
      if (tab == '课程') {
        this.getCollectCourseList()
      } else {
        this.getCollectPaperList();
      }
    },
    // 试卷收藏列表
    getCollectPaperList() {
      this.$Api.examination.getCollectPaperList(this.listParams).then(res => {
        this.testPaperList = res.data.data?.list;
        this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
      }).catch(() => { })
    },
    // 课程收藏列表
    getCollectCourseList() {
      this.$Api.course.getCollectCourseList(this.listQuery).then((res) => {
        this.listTotal = res.data.data.total;
        this.hotCourseList = res.data.data.list;
      }).catch(err => {
        console.log(err)
      });
    },
    showDeleteIcon(info) {
      this.hoverId = info.courseInfo.courseId;
    },
    hideDeleteIcon() {
      this.hoverId = "";
    },
    // 溢出收藏列表
    removeCollectedCourse(info) {
      this.$Api.course.collectCourse({ courseId: info.courseInfo.courseId }).then(res => {
        console.log(res);
        this.$Dialog.toast('移除成功');
        this.getCollectCourseList();
      }).catch(err => {
        console.log(err)
      })
    },
    // 详情
    goCourseDetail(info) {
      this.$Jump.href("/courseDetail", { courseId: info.courseId }, true);
    },
    // 查看试卷
    viewExamPaper(info) {
      this.href("/examPaperView", { paperDocumentId: info.paperDocumentId })
    }
  },
};
</script>
<style lang="scss" scoped>
.my_collect {
  font-weight: 500;
  font-size: 16px;
  color: #303030;
}

.tab_list {
  .btn_tab {
    width: 80px;
    height: 40px;
    background: #F6F7F9;
    border-radius: 12px;
    text-align: center;
    line-height: 40px;
    color: #8A919B;
  }

  .active_btn_tab {
    background: linear-gradient(97deg, #00D498 0%, #00D5C2 100%);
    color: #ffffff;
  }
}

.course_list {
  width: 100%;

  .course_one {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    border: 1px solid #e3e3e3;
    padding: 11px;
    box-sizing: border-box;
    height: 309px;
    margin-top: 12px;

    .course_one_top {
      position: relative;

      .course_one_img {
        width: 235px;
        height: 148px;
        border-radius: 10px;
      }

      .course_one_img_resize {
        width: 280px;
      }

      .course_one_type {
        position: absolute;
        right: 0;
        top: 0;
        width: 54px;
        height: 21px;
        background: rgba(0, 0, 0, 0.4);
        border-radius: 0px 20px 0px 20px;
        font-size: 14px;
        color: #ffffff;
        text-align: center;

        .delete_gray_icon {
          width: 18px;
          height: 18px;
        }
      }
    }

    .course_one_title {
      width: 235px;
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      margin: 5px 0;
      height: 70px;
    }

    .course_one_institution {
      .course_one_institution_left {
        .institutionName {
          color: #333333;
          margin-left: 6px;
          max-width: 150px;
        }
      }

      .course_num {
        color: #666666;
      }
    }

    .course_rate {
      :deep(.el-rate .el-rate__icon) {
        margin-right: 0;
      }

      :deep(.el-rate) {
        height: auto;
      }
    }

    .course_info {
      .course_online {
        font-size: 14px;
        color: #999999;
      }

      .course_price {
        color: #ff6619;
        font-size: 22px;
        font-weight: 600;

        .course_price_unit {
          font-size: 16px;
          font-weight: 400;
        }
      }

      .course_free {
        font-size: 16px;
        font-weight: 400;
      }
    }
  }

  .empty_course_one {
    opacity: 0;
  }
}

.test_paper_one {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  .test_paper_cover_icon {
    width: 82px;
    height: 92px;
  }

  .paper_info {
    // width: 300px;
    height: 90px;
    max-width: 380px;

    .paper_name {
      width: 100%;
      font-weight: 500;
      color: #303030;
      font-size: 14px;
    }

    .paper_tag {
      .tag_one {
        background: #eff1f4;
        border-radius: 4px;
        font-size: 11px;
        color: #606060;
      }
    }

    .paper_create {
      font-size: 12px;
      color: #606060;
    }
  }

  .paper_difficult {
    height: 80px;

    .btn_start {
      // width: 91px;
      height: 32px;
      background: linear-gradient(97deg, #00d498 0%, #00d5c2 100%);
      border-radius: 8px;
      text-align: center;
      line-height: 32px;
      font-size: 14px;
      color: #ffffff;
    }

    .paper_price {
      font-size: 14px;
      color: #FF6619;
      font-weight: 500;
    }
  }
}
</style>
